import _ from "lodash";

export function queryStringToJSON(query_string) {
    return  _.chain(query_string)
        .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
        .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
        .map(_.partial(_.split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
        .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
        .value()
}
